import { render, staticRenderFns } from "./SeleccionarGrupo.vue?vue&type=template&id=5898b986&scoped=true&"
import script from "./SeleccionarGrupo.vue?vue&type=script&lang=js&"
export * from "./SeleccionarGrupo.vue?vue&type=script&lang=js&"
import style0 from "./SeleccionarGrupo.vue?vue&type=style&index=0&id=5898b986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5898b986",
  null
  
)

export default component.exports